import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";

const useQueryLogo = ({
  groupType,
  corporateId,
  enabled = true,
  authorisation = "",
}: {
  groupType: string;
  corporateId: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    ["logo"],
    () =>
      httpClient(`${groupType}/${corporateId}/logo`, {
        authorisation,
      }).getBlob(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export default useQueryLogo;
